import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/mockData";
import { Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function FAQ() {
    return (
        <div>
            <section className="pt-20 pb-12 relative">
                <div className="absolute inset-0 mesh-bg opacity-60" />
                <div className="container-tight relative text-center max-w-3xl">
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                        Support
                    </p>
                    <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 dark:text-slate-50 text-balance">
                        Questions, answered.
                    </h1>
                    <p className="mt-5 text-lg text-slate-600 dark:text-slate-400">
                        Everything you might want to know before signing up.
                    </p>
                </div>
            </section>

            <section className="pb-24">
                <div className="container-tight max-w-3xl">
                    <Accordion type="single" collapsible className="space-y-3">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`f-${i}`}
                                className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 px-6"
                            >
                                <AccordionTrigger
                                    className="text-left text-base font-semibold py-5 hover:no-underline"
                                    data-testid={`faq-trigger-${i}`}
                                >
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-slate-600 dark:text-slate-400 leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-12 rounded-2xl bg-gradient-to-br from-indigo-50 to-violet-50 dark:from-indigo-950/40 dark:to-violet-950/40 border border-indigo-200 dark:border-indigo-900/40 p-8 text-center">
                        <Mail className="h-8 w-8 text-indigo-600 mx-auto" />
                        <h3 className="mt-4 text-xl font-bold text-slate-900 dark:text-slate-50">
                            Still have questions?
                        </h3>
                        <p className="mt-2 text-slate-600 dark:text-slate-400">
                            Our team replies within 4 business hours.
                        </p>
                        <Link to="/contact" className="mt-5 inline-block">
                            <Button className="bg-indigo-600 hover:bg-indigo-700">
                                Contact Support <ArrowRight className="ml-2 h-4 w-4" />
                            </Button>
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
